module.exports = __webpack_public_path__ + "img/paciente3.edd88ff8.png";